/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Benefits_Testimonial_NameInputs */

const en_mobile_benefits_testimonial_name = /** @type {(inputs: Mobile_Benefits_Testimonial_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`George Weasley`)
};

const es_mobile_benefits_testimonial_name = /** @type {(inputs: Mobile_Benefits_Testimonial_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`George Weasley`)
};

/**
* | output |
* | --- |
* | "George Weasley" |
*
* @param {Mobile_Benefits_Testimonial_NameInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_benefits_testimonial_name = /** @type {((inputs?: Mobile_Benefits_Testimonial_NameInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Benefits_Testimonial_NameInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_benefits_testimonial_name(inputs)
	return en_mobile_benefits_testimonial_name(inputs)
});